import { Button, Container, Stack, Typography } from '@mui/material';

import { tApp, tCommon } from '@frontend/locales';

export const ErrorView = () => {
  return (
    <Container
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        py: 2,
        width: '100%',
        height: '100%',
      }}
    >
      <Stack
        spacing={2}
        justifyContent="center"
        alignItems="center"
        maxWidth={430}
      >
        <Stack direction="column">
          <Typography variant="h5" textAlign="center">
            {tApp.errorPages.unexpectedError()}
          </Typography>

          <Typography variant="body1" maxWidth={376} textAlign="center">
            {tApp.errorPages.unexpectedErrorDescription()}
          </Typography>
        </Stack>

        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={() => {
            // By changing pathname here instead of using react-router navigation
            // lets the application reset which can help in clearing up bad state
            window.location.pathname = '/';
          }}
        >
          {tCommon.actions.goBack()}
        </Button>
      </Stack>
    </Container>
  );
};
